import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { SailingStatusType } from '../../renderTypes';


export default /*#__PURE__*/_defineComponent({
  __name: 'SailingStatus',
  props: {
    sailingStatus: {},
    statusText: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["sailingStatus", _ctx.sailingStatus])
  }, _toDisplayString(_ctx.statusText), 3))
}
}

})